import dayjs from "dayjs";
import z, { ZodIssueCode } from "zod";

/**
 * ConfigurarPagamentoSchema
 */

export const ConfigurarPagamentoSchema = z.object({
  valorTotal: z.coerce.number().optional(),
  fornecedor: z.string().optional(),
  titulo: z.string().optional(),
  formaPagamento: z.string().optional(),
  notaFiscal: z.string().optional(),
  pagamentoAvista: z.coerce.number().optional(),
  entrada: z.coerce.number().optional(),
  dataPagamento: z.coerce.date().optional(),
  pagamentoEm: z.coerce.number().optional(),
  valorEntrada: z.coerce.number().optional(),
  dataEntrada: z.coerce.date().optional(),
  nroParcelas: z.coerce.number().optional(),
  dataPrimeiroPagamento: z.coerce.date().optional(),
  nroDiasEntreParcelas: z.coerce.number().optional(),
  informacoesGerais: z.string().optional(),
}).superRefine((data, ctx) => {
  if (data.pagamentoAvista === 1) {

    // A Vista
    if (data.dataPagamento === undefined || data.dataPagamento === null) {
      ctx.addIssue({
        code: ZodIssueCode.custom,
        message: 'Este campo deve ser preenchido!',
        path: ['dataPagamento'],
      });
    } else {
      if (!dayjs(data.dataPagamento).isValid()) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: 'Este campo deve ser preenchido!',
          path: ['dataPagamento'],
        });
      }
    }
  } else {

    // Parcelado
    if (data.entrada !== undefined && data.entrada !== null && data.entrada === 1) {
      if (data.valorEntrada === undefined || data.valorEntrada === null) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: 'Este campo deve ser preenchido!',
          path: ['valorEntrada'],
        });
      }
      if (data.dataEntrada === undefined || data.dataEntrada === null) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: 'Este campo deve ser preenchido!',
          path: ['dataEntrada'],
        });
      }
    }

    if (data.nroParcelas === undefined || data.nroParcelas === null) {
      ctx.addIssue({
        code: ZodIssueCode.custom,
        message: 'Este campo deve ser preenchido!',
        path: ['nroParcelas'],
      });
    } else {
      if (isNaN(data.nroParcelas)) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: 'Este campo deve ser preenchido!',
          path: ['nroParcelas'],
        });
      }
    }

    if (data.dataPrimeiroPagamento === undefined || data.dataPrimeiroPagamento === null) {
      ctx.addIssue({
        code: ZodIssueCode.custom,
        message: 'Este campo deve ser preenchido!',
        path: ['dataPrimeiroPagamento'],
      });
    } else {
      if (!dayjs(data.dataPrimeiroPagamento).isValid()) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: 'Este campo deve ser preenchido!',
          path: ['dataPrimeiroPagamento'],
        });
      }
    }

    // Parcelado: Informar intervalo de dias
    if (data.pagamentoEm === 2) {
      if (data.nroDiasEntreParcelas === undefined || data.nroDiasEntreParcelas === null) {
        ctx.addIssue({
          code: ZodIssueCode.custom,
          message: 'Este campo deve ser preenchido!',
          path: ['dataPrimeiroPagamento'],
        });
      } else {
        if (isNaN(data.nroDiasEntreParcelas)) {
          ctx.addIssue({
            code: ZodIssueCode.custom,
            message: 'Este campo deve ser preenchido!',
            path: ['nroDiasEntreParcelas'],
          });
        }
      }
    }
  }
});

/**
 * ConfigurarPagamentoForm
 */

export type ConfigurarPagamentoForm = z.infer<typeof ConfigurarPagamentoSchema>;